import type { ReactNode } from 'react';
import { LogoLockup } from '../../../ui/Logo';

/**
 * Układ ekranów logowania (czeka na projekt w Figmie): szare tło aplikacji (bg/app), wyśrodkowana biała karta 400 px,
 * logo nad kartą, bez ozdobników.
 */
export function AuthLayout({
  title,
  description,
  children,
  footer,
}: {
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center bg-app px-4 pt-16 pb-10 md:pt-[max(64px,18vh)]">
      <main className="w-full max-w-[400px]">
        <div className="mb-8 flex justify-center">
          <LogoLockup />
        </div>
        <section className="rounded-2xl border border-line bg-panel px-6 py-7 shadow-xs md:px-8 md:py-8">
          <h1 className="text-h4 text-fg">{title}</h1>
          {description && <p className="mt-1.5 text-body-s text-fg-secondary">{description}</p>}
          <div className="mt-6">{children}</div>
        </section>
        {footer && <div className="mt-6 text-center text-body-s text-fg-muted">{footer}</div>}
      </main>
    </div>
  );
}
